// extracted by mini-css-extract-plugin
export default {"tagsContainer":"DiscoverNewReleases_tagsContainer__5wrC-"};